import axios from 'axios'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { 'Content-Type': 'application/json' }

export default class GenericService {
  static async downloadFile (endpoint, actionData = {}) {
    try {
      const { data } = await axios.put(`${url}${endpoint}`, JSON.stringify(actionData), { headers })
      return data
    } catch (error) {
      throw error.response
    }
  }
}
